import { Component, EventEmitter, Input, input, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators , ReactiveFormsModule, FormsModule, AbstractControl } from '@angular/forms';
import { InventoryService } from 'src/app/service/inventory.service';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgClass } from '@angular/common';
import { CrmService } from 'src/app/service/crm.service';
import { alertModalWithoutConfirm } from 'src/app/component/helpers/alert';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Component({
    selector: 'app-forward-req',
    imports: [MatInputModule, MatSelectModule, MatFormFieldModule, ReactiveFormsModule, FormsModule, NgClass],
    templateUrl: './forward-req.component.html',
    styleUrls: ["../../styles/inventory.css"]
})
export class ForwardReqComponent {
  @Input({required: true}) selectedInventory: any;
  @Input({required: true}) newInvReqId: any;
  @Output() requestForwarded = new EventEmitter<string>();
  forwardRequestForm: FormGroup;


  constructor(private router: Router, private fb: FormBuilder,private inventoryService: InventoryService, private crmService: CrmService){
    this.forwardRequestForm = this.fb.group({
      maximumCost: ['', [Validators.required,this.noWhitespaceValidator]],
      comment: ['', [Validators.required,this.noWhitespaceValidator]],
      link1: ['', [Validators.required,this.noWhitespaceValidator]],
      link2: [''],
      link3: [''],
      selectedAdmin: ['', Validators.required]
    })
  }

  ngOnInit() {
    this.getAdminUsersList();
    this.getNewInventory();
    console.log({selectedInventory: this.selectedInventory})
  }

ngOnChanges(changes: SimpleChanges): void {
  if (changes['selectedInventory'] && changes['selectedInventory'].currentValue) {
    console.log('Selected Inventory updated:', this.selectedInventory);
    this.resetForwardModal(); 
    this.forwardReqPatch();

  }
}

resetForwardModal(): void {
  this.forwardRequestForm.patchValue({
    maximumCost: '',
    comment: '',
    selectedAdmin: '',
    link1: '',
    link2: '',
    link3: ''
  });

  this.forwardRequestForm.markAsPristine();
  this.forwardRequestForm.markAsUntouched();

  Object.keys(this.forwardRequestForm.controls).forEach(key => {
    this.forwardRequestForm.get(key)?.setErrors(null);
  });

  this.showForwardSuccess = false;
  this.submitted = false;
  this.errorMessage = '';
}


  searchInventoryReqQuery: string;
 getInventoryRequest() {
    console.log("loggged");
    const field: any = {
      pageNum: 1,
      limit: 20,
      searchQuery: this.searchInventoryReqQuery,
    };
    this.inventoryService
      .getAllInventoryRequest(field)
      .subscribe((response) => {
        console.log("Response", response);
      });
  }

  blockNonNumeric(event: KeyboardEvent): void {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'];
    if (
      !/[0-9]/.test(event.key) &&
      !allowedKeys.includes(event.key)
    ) {
      event.preventDefault();
    }
  }

  adminUsers: { value: string, viewValue: string, id: string }[] = [];
  getAdminUsersList() {
    const department = "ADMIN";
    const loggedInUsername = localStorage.getItem("username");
    const loggedInUserId = localStorage.getItem("guestID");
    this.crmService.getAnyUsers(department).subscribe(
      (res) => {
        let data = res["data"];
        this.adminUsers = data.map((adminUser) => {
          return {
            value: adminUser.userName,
            viewValue: adminUser.userName,
            id: adminUser._id
          };
        });
      },
      (err) => {
        console.log(err);
      }
    );
  }

      // Price Formatting
      formatCurrency(value: string | number): string {
        if (!value) return "";
        return new Intl.NumberFormat("en-IN").format(Number(value));
      }
      onProductCostInput(event: Event): void {
        const input = event.target as HTMLInputElement;
        const value = input.value.replace(/,/g, "");
        this.forwardRequestForm.get("maximumCost")?.setValue(value, { emitEvent: false });
        input.value = this.formatCurrency(value);
      }


  showForwardSuccess = false;
  errorMessage = '';
  submitted = false;
   onSubmitForwardReq(newInventory: any) {
        console.log({ newInventory })
    console.log('REQUEST ID', newInventory.requestId)
    console.log(this.forwardRequestForm.value)
    this.submitted = true;
    const forwardReqValues = {
      ...this.forwardRequestForm.value
    };

    const linksArray = [
      forwardReqValues.link1,
      forwardReqValues.link2,
      forwardReqValues.link3
    ].filter(link => link);


    const getForwardRequestFormValue: any = {
      maximumCost: String(forwardReqValues.maximumCost),
      comment: String(forwardReqValues.comment),
      links: linksArray,
      requestId: newInventory.requestId,
      adminId: forwardReqValues.selectedAdmin,
      redirectUrl: `${environment.redirectUrl}#/inventory/admin-request?filter=New Inventory Request&tab=forwarded`
    };
    console.log(newInventory?.requestId, 'REQUEST ID')
    this.inventoryService.forwardRequest(getForwardRequestFormValue).subscribe(response => {
      console.log('submitted ', response);
      this.requestForwarded.emit(newInventory.requestId);
      this.showForwardSuccess = true
        const modalEl = document.querySelector('.modal.show') as any;
    if (modalEl) {
      (window as any).$(modalEl).modal('hide');
    }

    document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
      
      // window.location.reload();
      // this.getNewInventory();
       this.router.navigate(['/inventory/admin-request'], { 
    queryParams: { filter: 'New Inventory Request' } 
  });
    },
      error => {
       if (this.forwardRequestForm.invalid) {
          console.log("invalid");
          return alertModalWithoutConfirm(
            "warning",
            "Please fill in all required fields before submitting.",
          );
        }
        else  if (error.status === 400) {
          this.errorMessage = 'This request has already been submitted.';
        } 
      });
  }

  noWhitespaceValidator(control: AbstractControl): { [key: string]: any } | null {
    const isWhitespace = (control.value || '').trim().length === 0;
    return !isWhitespace ? null : { whitespace: true };
  }
  

  newInventories: any[] = []
  totalNewInventory: any;
  getNewInventory() {
    const field: any = {
      pageNum: 1,
      limit: 20,
    }
    console.log("loggged")
    this.inventoryService.getNewInventoryRequest(field).subscribe(response => {
      console.log("Response", response);
      this.newInventories = response['data'].records
      this.totalNewInventory = response['data'].totalCounts
      console.log(this.newInventories)
      
    })
  }

  forwardReqPatch() {
    console.log("Forward Patch", this.selectedInventory?.links);
  
    if (this.selectedInventory?.links && Array.isArray(this.selectedInventory.links)) {
      this.forwardRequestForm.patchValue({
        link1: this.selectedInventory.links[0] || '',
        link2: this.selectedInventory.links[1] || '',
        link3: this.selectedInventory.links[2] || ''
      });
    } else {
      console.warn("No links found in selectedInventory");
    }
  }
  
  forwardReqReset() {
    this.forwardRequestForm.patchValue({
      maximumCost: '',
      comment: '',
      selectedAdmin: ''
    });
  
    //reset validation states
    ['maximumCost', 'comment', 'selectedAdmin'].forEach(field => {
      const control = this.forwardRequestForm.get(field);
      control?.markAsPristine();
      control?.markAsUntouched();
    });
  
    this.showForwardSuccess = false;
    this.submitted = false;
  }
  
  
  
}
